import React from 'react';
import q from 'q';
import { connect } from 'react-redux';

import {
    Popover,
    Button,
    Row,
    Col,
    DatePicker,
    Select,
    Upload,
    message
} from 'antd'

import {
    _getQbPaymentMethods,
    _getQbDepositToAccounts,
} from '../../services'

import { API_ENDPOINT } from '../../index';

const { Option } = Select;
const productionEnvString = "production";

class PaymentAdviceButton extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            paymentMethods: false,
            depositToAccounts: false,

            popoverVisible: false,
        }
    }
    
    render() {
        return (
            this.renderPaymentAdviceButton()
        )
    }

    componentDidMount() {
        q.all([
            _getQbPaymentMethods(),
            _getQbDepositToAccounts(),
        ])
        .then( ([paymentMethodsRes, depositToAccountsRes]) => {
            const { paymentMethods } = paymentMethodsRes.data
            const { depositToAccounts } = depositToAccountsRes.data

            let paymentAdviceActivePaymentMethodId = 
            process.env.NODE_ENV == productionEnvString?
                paymentMethods["Paypal"].Id
                :
                paymentMethods["Cash"].Id

            let paymentAdviceActiveDepositToId = 
            process.env.NODE_ENV == productionEnvString?
                depositToAccounts["UOB Current"].Id
                :
                depositToAccounts["Inventory"].Id

            this.setState({
                paymentMethods,
                depositToAccounts,
                paymentAdviceActivePaymentMethodId,
                paymentAdviceActiveDepositToId
            })

        })
    }

    renderPaymentAdviceButton = () => {

		// const { order } = this.state

		return (
            <Popover
                trigger="click"
                placement="bottom"
                content={this.renderPaymentAdviceUploadForm()}
                visible={this.state.popoverVisible && this.props.batchDetails.length > 0}
                >
                <Button
                    onClick={()=>this.setState({popoverVisible: !this.state.popoverVisible})}
                    disabled={this.props.batchDetails.length <= 0}
                    > Payment Advice</Button>
            </Popover>
		)

    }
    
    renderPaymentAdviceUploadForm = () => {
		const { paymentMethods, depositToAccounts } = this.state

		// console.log(paymentMethods)
        // console.log(depositToAccounts)

		return(
			<React.Fragment>
                <Row type="flex" justfiy="start">
                    Payment Method
                </Row>
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <Select 
                    placeholder="Payment Method"
                    value={this.state.paymentAdviceActivePaymentMethodId}
                    onChange={(val) =>this.setState({paymentAdviceActivePaymentMethodId:val})}
                    style={{width:150}}>
                        {Object.keys(paymentMethods).map(_key =>
                        <Option value={paymentMethods[_key].Id}>
                            {paymentMethods[_key].Name}
                        </Option>
                        )}
                    </Select>
                </Row>
                <Row type="flex" justfiy="start">
                    Deposit to
                </Row>
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <Select 
                    value={this.state.paymentAdviceActiveDepositToId}
                    placeholder="Deposit to"
                    onChange={(val) =>this.setState({paymentAdviceActiveDepositToId:val})}
                    style={{width:150}}>
                        {Object.keys(depositToAccounts).map(_key =>
                        <Option value={depositToAccounts[_key].Id}>
                            {depositToAccounts[_key].Name}
                        </Option>
                        )}
                    </Select>
                </Row>
                <Row type="flex" justfiy="start">
                    Payment Date
                </Row>
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <DatePicker
                        style={{width: 150}}
                        onChange={(date) =>this.setState({paymentAdviceDate: date})}
                    />
                </Row>
                <Row style={{marginBottom:8}} type="flex" justify="center">
                    <Upload
                        withCredentials
                        data={{
                            date: JSON.stringify(this.state.paymentAdviceDate),
                            paymentMethodId: JSON.stringify(this.state.paymentAdviceActivePaymentMethodId),
                            accountId: JSON.stringify(this.state.paymentAdviceActiveDepositToId),
                            uploadedBy: JSON.stringify(this.props.user.data.details.name),
                            refNumbers: JSON.stringify(this.props.refNumbers),
                            batchDetails: JSON.stringify(this.props.batchDetails),
                            creditPaymentRefNumber: JSON.stringify(this.props.creditPaymentRefNumber),
                            amount: JSON.stringify(this.props.amount)
                        }}
                        action={`${API_ENDPOINT}/api/admin/order-docs/upload-payment-advice-multiple-invoice/${this.props.user.data._id}`}
                        onChange={ (info) => this.handleOnChangeUploadPaymentAdvice(info) }
                        >
                        <Button
                            style={{width:150}}
                            disabled={!this.state.paymentAdviceActivePaymentMethodId || !this.state.paymentAdviceActiveDepositToId}
                            type="primary">Upload</Button> 
                    </Upload>
                </Row>
			</React.Fragment>
		)
    }
    
    handleOnChangeUploadPaymentAdvice = (info) => {
        console.log(info.file)
		if(info.file.status === "done" && info.file.response.success){
			message.success(`Payment Advice uploaded`)
            this.props.getCreditPayment()
		}

		if(info.file.status === "error"){
			message.error(`Error uploading payment advice`, 10)
		}
	}

}

export default connect(
    state => ({
		user: state.user
	}),
)(PaymentAdviceButton)


// WEBPACK FOOTER //
// ./src/components/credit-payment/payment-advice-button.js